<template>
    <Badge :variant="variant" class="gap-1 rounded-none">
        <span class="size-1.5 rounded-full" :class="dotClass" />
        {{ label }}
    </Badge>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { Badge } from '@/components/ui/badge';

const props = defineProps<{
    status: 'active' | 'inactive';
}>();

const label = computed(() => (props.status === 'active' ? 'Active' : 'Inactive'));

const variant = computed(() => (props.status === 'active' ? 'success' : 'warning'));

const dotClass = computed(() =>
    props.status === 'active' ? 'bg-new-green-700' : 'bg-new-orange-700',
);
</script>
